import type { SidebarProps } from './sidebar.types';
import PRIO_GROUP_TYPE from '@/components/landing-page/utils/prio-group-type';
import Group from '@/components/landing-page/components/group';
import { defaults } from '@/components/landing-page/components/sidebar';
import { cn } from '@/utils/helper';
import v1 from '@/components/landing-page/components/sidebar/sidebar-v1.module.css';
import v2 from '@/components/landing-page/components/sidebar/sidebar-v2.module.css';

const Sidebar = (props: SidebarProps) => {
  const { groups = defaults.groups } = props;

  if (!groups.length) return null;

  const main = groups.filter((group) => group.type !== PRIO_GROUP_TYPE.CONTACT_US);
  const contact = groups.filter((group) => group.type === PRIO_GROUP_TYPE.CONTACT_US);

  return (
    <aside className={cn(v1.Sidebar, v2.Sidebar)}>
      <div className={cn(v1.Main, v2.Main)}>
        {main.map((group) => (
          <Group key={group.id} group={group} groupClassName={cn(v1.Item, v2.Item)} />
        ))}
      </div>
      {contact.map((group) => (
        <Group key={group.id} group={group} />
      ))}
    </aside>
  );
};

export default Sidebar;
